<div class="card mb-3">
    <div class="card-header bg-secondary-subtle d-flex">
        <div class="fs-5">
            {{ contact.name}}
        </div>
        <button class="btn btn-light ms-auto" (click)="collapse.toggle()" [attr.aria-expanded]="collapsed" aria-controls="address">
            @if (collapsed) {
                <i class="bi bi-caret-up-fill"></i>
            } @else {
                <i class="bi bi-caret-down-fill"></i>
            }
        </button>
    </div>
    <div class="card-body" class="collapse" #collapse="ngbCollapse" [(ngbCollapse)]="collapsed">
        <ul class="ms-2 mt-2">
            @for (name of nameList; track $index) {
                <li>
                    {{name}}
                </li>
            }
        </ul>
    </div>
</div>
